/**
 * Fixtures for the Decisions feature
 */

export const FEEDBACK_EXAMPLE_DATA = [
  {
    prediction_uuid: "9fb3ac6f-a68b-46ab-8eae-2fb6b759ba38",
    feedback: "feedbackSidebar.example.value1",
  },
  {
    prediction_uuid: "dfc95191-c768-4b7f-9982-1be29f0a52ba",
    feedback: "feedbackSidebar.example.value2",
  },
] as const
